import { useGetSandboxes } from '@/api/getSandboxes';
import {
  Select,
  SelectTrigger,
  SelectContent,
  SelectValue,
  SelectItem,
} from '@/components/ui/select';
import { useGame } from '@/hooks/useGame';
import { storeGameSandbox } from '@/lib/utils';
import { useSandboxContext } from '@/providers';

import { SandboxActionsMenu } from './sandboxActionsMenu';

/**
 * Sandbox Toolbar Component
 * Displays sandbox selector and action menu
 * Extracted from breadcrumb to keep breadcrumb as a pure display component
 */
export const SandboxToolbar = () => {
  const { selectedSandbox } = useSandboxContext();
  const game = useGame();
  const { data: sandboxes } = useGetSandboxes({ game_code: game.game_code });

  const handleSandboxChange = (newSandbox: string) => {
    if (newSandbox !== selectedSandbox) {
      // Store the new sandbox in localStorage first
      storeGameSandbox(game.game_code, newSandbox);

      // Show warning to user about navigation
      if (confirm('Switching sandboxes will navigate you to the home page.')) {
        // Navigate to home route to avoid issues with stale IDs in URL
        // (e.g., snapshot IDs, player IDs that don't exist in the new sandbox)
        window.location.href = `/game/${game.game_code}/${newSandbox}/players`;
      }
    }
  };

  return (
    <div className="ml-auto flex items-center gap-2">
      {sandboxes && (
        <Select value={selectedSandbox} onValueChange={handleSandboxChange}>
          <SelectTrigger className="h-9 w-[180px]">
            <SelectValue placeholder="Select a sandbox" />
          </SelectTrigger>
          <SelectContent>
            {sandboxes.sandboxes.map((sandbox) => (
              <SelectItem key={sandbox.code} value={sandbox.code}>
                {sandbox.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
      <SandboxActionsMenu />
    </div>
  );
};
